/**
 * Adapted from rippleJS (https://github.com/samthor/rippleJS, version 1.0.3)
 *
 */
import './../styles/animation/active.css';
import classlist from './../utils/classlist';
import element from './../utils/element';

const startRipple = function (eventType, event) {
	let holder = event.currentTarget || event.target;

	if (holder.localName !== 'button' || !holder.childNodes.length) {
		holder = classlist.has(holder, 'v5-active') ? holder : null;
	}

	if (holder && !classlist.has(holder, 'v5-active')) {
		holder = holder.querySelector('.v5-active');
	}

	if (!holder) {
		return;
	}

	// Store the event use to generate this ripple on the holder: don't allow
	// further events of different types until we're done. Prevents double
	// ripples from mousedown/touchstart.
	const prev = holder.getAttribute('data-ui-event');

	if (prev && prev !== eventType) {
		return;
	}

	holder.setAttribute('data-ui-event', eventType);

	// Get ripple position
	const rect = holder.getBoundingClientRect();
	const x = event.clientX - rect.left;
	const y = event.clientY - rect.top;

	// Create the ripple
	const ripple = document.createElement('div');

	//center ripple
	if (rect.width === rect.height) {
		// Position the ripple
		ripple.style.width = rect.width + 'px';
		ripple.style.height = rect.width + 'px';
	} else {
		let max = Math.sqrt((rect.width * rect.width) + (rect.height * rect.height));
		let size = (max * 2) + 'px';
		// Position the ripple
		ripple.style.width = size;
		ripple.style.height = size;
		ripple.style.marginLeft = -max + x + 'px';
		ripple.style.marginTop = -max + y + 'px';
	}

	// Add the ripple element
	ripple.className = 'v5-active__ripple';
	holder.appendChild(ripple);

	setTimeout(() => {
		classlist.add(ripple, 'is-held');
	}, 0);

	const releaseEvent = (eventType === 'mousedown' ? 'mouseup' : 'touchend');

	const handleRelease = function () {
		document.removeEventListener(releaseEvent, handleRelease);

		classlist.add(ripple, 'is-done');

		// Larger than the animation duration in CSS
		const timeout = 650;

		setTimeout(() => {
			holder.removeChild(ripple);

			if (holder.children.length === 0) {
				holder.removeAttribute('data-ui-event');
			}
		}, timeout);
	};

	document.addEventListener(releaseEvent, handleRelease);
};

const handleMouseDown = function (e) {
	// Trigger on left click only
	if (e.button === 0) {
		startRipple(e.type, e);
	}
};

const handleTouchStart = function (e) {
	if (e.changedTouches) {
		for (let i = 0; i < e.changedTouches.length; ++i) {
			startRipple(e.type, e.changedTouches[i]);
		}
	}
};

export default {
	name: 'v5-active',
	props: {
		ripple: {
			type: Boolean,
			default: true
		},
		activeColor: {
			type: String
		}
	},

	watch: {
		trigger() {
			this.setupRipple();
		}
	},

	created() {
		// Instance data, not declared in data() as we don't want reactivity.
		this.triggerEl = null;
	},

	mounted() {
		let el = document.createElement('div');
		el.className = 'v5-active';
		if (this.activeColor) {
			el.style.color = this.activeColor;
		}
		this.$el.appendChild(el);
		this.setupRipple();
	},

	beforeDestroy() {
		this.destroyRipple();
	},

	methods: {
		setupRipple() {
			this.triggerEl = element.resolve(this.trigger, this.$el.parentElement);

			if (!this.triggerEl) {
				console.error('[UiRippleInk]: Trigger element not found.');
				return;
			}

			this.triggerEl.addEventListener('touchstart', handleTouchStart);
			this.triggerEl.addEventListener('mousedown', handleMouseDown);
		},

		destroyRipple() {
			if (!this.triggerEl) {
				return;
			}

			this.triggerEl.removeEventListener('mousedown', handleMouseDown);
			this.triggerEl.removeEventListener('touchstart', handleTouchStart);
		}
	}
};



// WEBPACK FOOTER //
// ./~/@58fe/v5/src/mixins/active.js